import { CRUDAction, FeatureKey } from 'common/constants/permission'
import useMedia from 'common/hooks/useMedia'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { RecordFeatureButton } from 'components/RecordFeatureButton'

import GrowthShrimpChart from '../GrowthShrimpChart'
import GrowthShrimpDialog from '../GrowthShrimpDialog'
import GrowthShrimpTable from '../GrowthShrimpTable'

const GrowthShrimp = () => {
  const { t } = useTranslation(['growth'])
  const isMobile = useMedia('sm')
  const showRecordBtn = usePermitToActionFeature([CRUDAction.Create], FeatureKey.Growth)

  return (
    <Box sx={{ py: isMobile ? 0 : 3 }}>
      <RecordFeatureButton
        buttonText={t('growth:record.growth')}
        dialog={({ open, onClose }) => <GrowthShrimpDialog open={open} onClose={onClose} />}
        showButton={showRecordBtn}
      />
      <Grid container spacing={2} sx={{ height: 'max-content' }}>
        <Grid item xs={12}>
          <GrowthShrimpChart />
        </Grid>
        <Grid item xs={12}>
          <GrowthShrimpTable />
        </Grid>
      </Grid>
    </Box>
  )
}

export default GrowthShrimp
